import Vue from 'vue'
import VueI18n from 'vue-i18n'
import BootstrapVue from 'bootstrap-vue'
import VueGtm from 'vue-gtm'
import App from './App.vue'
import router from './router'
import store from './store'
import { getLanguage } from './utils'
import { fetchLocations, fetchPages, fetchQuestions, fetchRealtors } from './backend'
import vueSmoothScroll from 'vue2-smooth-scroll'
import vObjectFit from 'v-object-fit'
import fi from './languages/fi'
import sv from './languages/sv'

import './scss/custom.scss'

Vue.config.productionTip = false
Vue.use(BootstrapVue)
Vue.use(VueI18n)
Vue.use(vueSmoothScroll)
Vue.directive('object-fit', vObjectFit)
Vue.use(VueGtm, {
  id: 'GTM-TPBPB3P',
  vueRouter: router
})

export const i18n = new VueI18n({
  locale: 'fi', // set default locale
  messages: { fi: fi, sv: sv } // set locale messages
})

// You can use this to run functions on the store. These should be kept very light.
store.subscribe((mutation, state) => {
  // Transfer store.language to i18n module on store change
  if (mutation.type === 'language' || mutation.type === 'initialiseStore') {
    if (state.language) {
      i18n.locale = state.language
      document.documentElement.setAttribute('lang', state.language)
    }
  }

  // Get data
  if (Object.keys(store.state.pages).length === 0) {
    fetchPages()
  }
  if (Object.keys(store.state.questions.hobbies).length === 0) {
    fetchQuestions()
  }
  if (Object.keys(store.state.realtors).length === 0) {
    fetchRealtors()
  }
  if (Object.keys(store.state.locations).length === 0) {
    fetchLocations()
  }
})

const init = () => {
  if (!store.state.language.length) {
    store.commit('language', { language: getLanguage() })
  }
}

new Vue({
  router,
  store,
  beforeCreate () {
    this.$store.commit('initialiseStore', { store: localStorage.getItem('store'), hmac: localStorage.getItem('hmac') })
  },
  i18n,
  render: h => h(App)
}).$mount('#app')

init()
